var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
var DeleteModal = /** @class */ (function () {
    function DeleteModal(dialogClient) {
        this.dialogClient = dialogClient;
    }
    DeleteModal.prototype.activate = function (vm) {
        this._vm = vm;
    };
    DeleteModal.prototype.yes = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var result = _this._vm.delete(); // could be void | PromiseLike<any>
                Promise.resolve(result)
                    .then(function () { return resolve(); })
                    .catch(function (err) { return reject(err); });
            }
            catch (err) {
                reject(err);
            }
        });
    };
    DeleteModal.prototype.no = function () {
        this.dialogClient.hide();
    };
    DeleteModal = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService])
    ], DeleteModal);
    return DeleteModal;
}());
export { DeleteModal };
